var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions-type-preview"},[(!_vm.editMode)?[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subTitle))])]:_vm._e(),_c('div',{staticClass:"questions-type-preview__example input-group",class:{
      'questions-type-preview__example--builder': _vm.builderMode,
      'questions-type-preview__example--edit': _vm.editMode,
    }},[_vm._t("default")],2),_c('p',{staticClass:"questions-type-preview__description"},[_c('small',[_vm._v(_vm._s(_vm.description))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }